import type SVGProps from '~/components/icons/svg-props'

export type ErrorIconProps = SVGProps & {
  variant?: 'outlined' | 'filled'
}

export default function ErrorIcon(props: ErrorIconProps) {
  const { variant, ...rest } = props
  return variant === 'filled' ? (
    <ErrorIconFilled width="16" height="16" {...rest} />
  ) : (
    <ErrorIconOutlined width="16" height="16" {...rest} />
  )
}

function ErrorIconOutlined(props: SVGProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.1677 9.18107C9.89526 8.90862 9.45352 8.90862 9.18106 9.18107C8.9086 9.45353 8.9086 9.89528 9.18106 10.1677L11.0133 12L9.18108 13.8322C8.90862 14.1047 8.90862 14.5464 9.18108 14.8189C9.45354 15.0914 9.89528 15.0914 10.1677 14.8189L12 12.9867L13.8322 14.8189C14.1047 15.0913 14.5464 15.0913 14.8189 14.8189C15.0913 14.5464 15.0913 14.1047 14.8189 13.8322L12.9866 12L14.8189 10.1678C15.0913 9.8953 15.0913 9.45355 14.8189 9.18109C14.5464 8.90863 14.1047 8.90863 13.8322 9.18109L12 11.0133L10.1677 9.18107Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3.39535 12C3.39535 7.24778 7.24778 3.39535 12 3.39535C16.7522 3.39535 20.6047 7.24778 20.6047 12C20.6047 16.7522 16.7522 20.6047 12 20.6047C7.24778 20.6047 3.39535 16.7522 3.39535 12Z"
        fill="currentColor"
      />
    </svg>
  )
}

function ErrorIconFilled(props: SVGProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.96963 8.96965C9.26252 8.67676 9.73739 8.67676 10.0303 8.96965L12 10.9393L13.9696 8.96967C14.2625 8.67678 14.7374 8.67678 15.0303 8.96967C15.3232 9.26256 15.3232 9.73744 15.0303 10.0303L13.0606 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0303 15.0303C9.73742 15.3232 9.26254 15.3232 8.96965 15.0303C8.67676 14.7374 8.67676 14.2625 8.96965 13.9697L10.9393 12L8.96963 10.0303C8.67673 9.73742 8.67673 9.26254 8.96963 8.96965Z"
        fill="currentColor"
      />
    </svg>
  )
}
